<style lang="less">
    .cursor{
        cursor: pointer;
    }
    .vipCards{
        width: 100%;
        position: relative;
        .vipCards_bg{
            width: 100%;
            height: 276px;
            .bg_content{
                text-align: left;
                width: 1200px;
                height: 276px;
                margin: 0 auto;
                padding: 38px;
                position: relative;
                .buy_title{
                    color: #fff;
                }
                .vipCard{
                    position: absolute;
                    left: 50%;
                    bottom: -110px;
                    margin-left: -362px;
                    width: 725px;
                    height: 305px;
                    padding: 40px 78px;
                    text-align: left;
                    color: #484848;
                    background-size: 100% 100% !important;
                    p{
                        font-size: 20px;
                        span{
                            font-size: 26px;
                            font-weight: bold;
                            display: inline-block;
                            margin-right: 13px;
                        }
                    }
                    ul{
                        font-size: 22px;
                        margin-top: 34px;
                        li{
                            padding: 6px 0;
                        }
                    }
                }
            }
        }
        .buy_contnet{
            width: 1200px;
            margin: 130px auto 30px;
            .buy_userInfo{
                border-radius: 10px;
                background-color: #fff;
                height: 224px;
                font-size: 16px;
                color: #333;
                padding: 20px 80px;
                text-align: left;
                .title{
                    height: 24px;
                    line-height: 24px;
                    font-size: 15px;
                    padding: 0 11px;
                    border-left: 3px solid #6851FF;
                }
                ul{
                    margin-top: 10px;
                    padding-left: 11px;
                    li{
                        &:nth-of-type(2){
                            color: #999999;
                            font-size: 14px;
                            margin: 12px 0 25px;
                        }
                        &:nth-of-type(3){
                            display: flex;
                            align-items: center;
                            height: 30px;
                            padding-bottom: 15px;
                            border-bottom: 1px solid #E0E0E0;
                            span{
                               display: inline-block;  
                               height: 24px;
                               margin-right: 11px;
                            }
                            input{
                                min-width: 100px;
                                height: 24px;
                                background-color: #fff;
                                outline: none;
                                border: none;
                            }
                        }
                        &:nth-of-type(4){
                            padding-top: 15px;
                            span{
                               display: inline-block;  
                               height: 24px;
                               margin-right: 11px;
                            }
                            input{
                                min-width: 100px;
                                height: 24px;
                                background-color: #fff;
                                outline: none;
                                border: none;
                            }
                        }
                    }
                }
            }
            .accountBox{
                margin-top: 40px;
                height: 520px;
                >p{
                    font-size: 22px;
                    font-weight:bold;
                    color: #333;
                }
                .accountInfo{
                    height: 322px;
                    background-color: #fff;
                    border-radius: 10px;
                    margin-top: 20px;
                    padding: 30px 80px;
                    .accountSum{
                        text-align: left;
                        border-left: 3px solid #6851FF;
                        padding-left: 10px;
                        height: 24px;
                        line-height: 24px;
                        color: #4D4D4D;
                        font-weight: bold;
                        >span{
                            font-weight: 400;
                            font-size: 25px;
                            color: #F25E5E;
                           span{
                               font-size: 30px;
                               font-weight: bold;
                           } 
                        }
                    }
                    .chooseWay{
                        text-align: left;
                        border-left: 3px solid #6851FF;
                        padding-left: 10px;
                        height: 24px;
                        line-height: 24px;
                        color: #4D4D4D;
                        font-weight: bold;
                        margin-top: 30px;
                    }
                    .accountWay{
                        width: 840px;
                        margin: 42px auto 0;
                        display: flex;
                        justify-content: space-between;
                        color: #333333;
                        >div{
                            border-radius: 10px;
                            border: 1px solid #fff;
                            padding: 19px 21px 24px;
                            width: 260px;
                            display: flex;
                            align-items: center;
                            position: relative;
                            .wayIcon{
                                width: 55px;
                                height: 55px;
                                margin-right: 15px;
                                img{
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                            ul{
                                li{
                                    &:nth-of-type(1){
                                        font-size:28px;
                                        font-weight: bold;
                                    }
                                     &:nth-of-type(2){
                                         font-size:21px;
                                        //  margin-top: 10px;
                                     }
                                    
                                }
                            }
                            .nowWay{
                                width: 28px;
                                height: 28px;
                                background-color: #5147E7;
                                border-radius:6px 0px 6px 0px;
                                position: absolute;
                                right: 0;
                                bottom: 0;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                            }
                        }
                    }
                    
                }
                .userNotice{
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    margin-top: 10px;
                    .notice_content{
                        font-size: 18px;
                        color: #333;
                        margin-left: 10px;
                        .theNotice{
                            color: #5147E7;
                            cursor: pointer;
                        }
                    }
                }
                .payBtn{
                    width:180px;
                    height:56px;
                    line-height: 56px;
                    text-align: center;
                    color: #fff;
                    font-size: 24px;
                    background:linear-gradient(270deg,rgba(104,81,255,1) 0%,rgba(100,146,241,1) 100%);
                    border-radius:6px;
                    cursor: pointer;
                    margin: 48px auto;
                }
                
            }
        }
        .codeBox{
            position: fixed;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background:rgba(77,77,77,1);
            opacity:0.6;
        }
        .codeBg{
            width: 260px;
            height: 320px;
            background-color: #fff;
            position: fixed;
            left: 50%;
            top: 50%;
            margin-left: -130px;
            margin-top: -160px;
            border-radius:10px;
            >div{
                margin: 0 auto;
                display: flex;
                justify-content: center;
            }
            .back{
                display: flex;
                justify-content: flex-end;
                padding: 10px 10px;
                img{
                    cursor: pointer;
                }
            }
            .qctitle{
                color: #333;
                font-size: 14px;
                font-weight: bold;
                margin-bottom: 16px;
            }
            .payPrice{
                color: #5147E7;
                font-size: 20px;
                margin: 20px auto;
            }
            .prompt{
                font-size: 14px;
                color: #5E5E5E;
            }
        }
    }
</style>
<template>
    <div class="vipCards">
        <div class="vipCards_bg" :style="{background:'url('+bg+')'}">
            <div class="bg_content">
                <div class="buy_title"><span @click="goBack" class="cursor">会员服务</span>&nbsp;<i class="el-icon-arrow-right"></i>&nbsp;<span>购买会员</span></div>
                <div class="vipCard" :style="{background:'url('+nowCard.bg+') no-repeat'}">
                    <p><span>{{nowCard.title}}</span>{{nowCard.price}}/{{nowCard.exp}}</p>
                    <ul>
                        <li v-for="(value,index) in nowCard.include" :key="index">{{index+1}}.{{value}}</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="buy_contnet">
            <div class="buy_userInfo">
                <p class="title">您好，<span>{{userData.name}}</span>:</p>
                <ul>
                    <li v-if="buyId != 22">您将购买柜柜{{(buyId == 20 || buyId == 21)?'云仓会员':''}}</li>
                    <li v-if="buyId == 22">您将购买柜柜{{buyId == 22?'云仓代理':''}}</li>
                    <li>请仔细填写以下信息，以便我们为您邮寄画册、色板</li>
                    <li><span>联系电话</span><input type="text" placeholder="请输入电话" v-model="phone"></li>
                    <li><span>收货地址</span><input type="text" placeholder="举例：成都市天府三街88号T1-1005" v-model="address"></li>
                </ul>
            </div>
            <div class="accountBox">
                <p>支付</p>
                <div class="accountInfo">
                    <p class="accountSum">总需支付：<span>￥<span>{{product.price}}</span></span></p>
                    <p class="chooseWay">请选择支付方式：</p>
                    <div class="accountWay">
                        <div class="cursor" @click="changeWay" :style="{'border':accountWay == 'Wechat'?'1px solid #5147E7':'1px solid #fff'}">
                            <div class="wayIcon" ><img src="../../assets/icon_wechat.png" alt=""></div>
                            <ul>
                                <li>微信支付</li>
                                <li>Wechat Pay</li>
                            </ul>
                            <div class="nowWay" v-show="accountWay == 'Wechat'"><img src="../../assets/icon_select.png" alt=""></div>
                        </div>
                        <div class="cursor" @click="changeWay" :style="{'border':accountWay == 'ALIPAY'?'1px solid #5147E7':'1px solid #fff'}">
                            <div class="wayIcon"><img src="../../assets/icon_alipay.png" alt=""></div>
                            <ul>
                                <li>支付宝</li>
                                <li>ALIPAY</li>
                            </ul>
                            <div class="nowWay" v-show="accountWay == 'ALIPAY'"><img src="../../assets/icon_select.png" alt=""></div>
                        </div>
                    </div>
                </div>
                <div class="userNotice">
                    <div @click="isNotice = !isNotice"><img v-if="isNotice" src="../../assets/icon_checkbox.png" alt=""><img v-if="!isNotice" src="../../assets/icon_checkbox_confirm.png" alt=""></div>
                    <div class="notice_content"><span>我已阅读并同意</span><span class="theNotice">《柜柜软件在线客户购买须知》</span></div>
                </div>
                <div class="payBtn" @click="payBtn">确认支付</div>
            </div>
        </div>
        <div class="codeBox" v-if="codeShow"></div>
            <div class="codeBg" v-if="codeShow">
                <div class="back"><img @click="noPay" src="../../assets/icon_chacha_b.png" alt=""></div>
                <p class="qctitle">请支付订单</p>
                <Qrcode :codeUrl='codeInfo.url'></Qrcode>
                <p class="payPrice">需支付金额：{{product.price}}</p>
                <p class="prompt">请使用微信扫码支付</p>
            </div>
        
    </div>
</template>
<script>
import QRCode from "qrcodejs2";
import Qrcode from '../../components/cloud/Qrcode'
export default {
    components:{
        Qrcode
    },
    props:['buyId'],
    data(){
        return{
            bg:require('../../assets/buyBack.png'),
            id:22,
            accountWay:'Wechat',
            codeShow:false,
            isNotice:false,//用户协议
            address:'',
            codeInfo:'',
            phone:'',
            wechatCode:'',
            clearTime:'',
            userData:{},
            product:{},//当前买的产品
            cards:[{
					id:1,
					title:"云仓会员",
					price:"980",
					exp:"终生",
					include:["享云仓会员价", "云仓专用柜柜画图软件，电子色卡、画册", "仓库管理系统(进销存)"],
					color:"#484848",
					bg:require('../../assets/ying.png'),
				},{
					id:2,
					title:"云仓代理",
					price:"3980",
					exp:"终生",
					include:["配送20个会员账号，追加账号折扣50%", "享有云仓平台材料返利", "享有云仓平台软件返利"],
					color:"#674302",
					bg:require('../../assets/gold_pc.png'),
				}],
        }
    },
    computed:{
        nowCard(){
            switch(this.id){
                case 21: case 20:
                    return this.cards[0]
                case 22:
                    return this.cards[1]
                    break;
            }
            
        }
    },
    methods:{
        getAddress(){
            // this.axios.get('https://ggtools.thinkerx.com/erp/get_address',{
            //     params:{
            //         uid:this.userData.id,
            //         condition:'default'
            //     }
            // }).then(res => {
            //     if(res.data.data.length){
            //         this.address = res.data.data[0].address
            //     }
            // })
            this.$get("/py/erp/get_address",{
                uid:this.userData.id,
                condition:'default'
            },res => {  
                if(res.data.length){
                    this.address = res.data[0].address
                }
            })
        },
        changeWay(){
            if(this.accountWay == 'Wechat'){
                this.accountWay = 'ALIPAY'
            }else{
                this.accountWay = 'Wechat'
            }
        },
        goBack(){
            this.$emit('back')
        },
        payBtn(){
            let that = this
            if(this.address==""){
                this.$message("请输入地址")
                return
            }
            var phoneReg = new RegExp("^[1][0-9]{10}$");
            // console.log(that.manageUsePhone)
            if(this.phone==""||!phoneReg.test(this.phone)){
                this.$message("请输入正确的手机号")
                return
            }
            if(this.isNotice){
                this.$message("请阅读并勾选购买须知")
                return
            }
            let other_info=JSON.stringify({
                phone:this.phone,
                address:this.address
            })
            // 微信支付
            if(this.accountWay == 'Wechat'){
                // this.axios.post('https://guigui.admin.thinkerx.com/pay/buyCloudWechat',{
                //     uid:this.userData.id,
                //     product_id:this.id,
                //     pay_type:"NATIVE",
                //     other_info:other_info
                // }).then(res => {
                //     console.log('url',res.data.data.url)
                //     this.codeInfo = res.data.data
                //     this.codeShow = true
                //     this.clearTime = setInterval(() =>{
                //         this.axios.post('https://guigui.admin.thinkerx.com/pay/checkWechatOrder',{
                //             order_num:res.data.data.order_num
                //         }).then(res => {
                //             if(res.data.data == 1){
                //                 clearInterval(this.clearTime)
                //                 this.axios('https://guigui.admin.thinkerx.com/wechat_app/user_info?phone='+this.userData.phone).then(res=>{
                //                     localStorage.data=JSON.stringify(res.data.data)
                //                     this.codeShow = false
                //                     this.$message.success('支付成功')
                //                     this.$emit('toCenter','个人中心')
                //                 })
                                
                //             }
                //         })
                //     },4000)
                // })
                this.$post("/system/pay/buyCloudWechat",{
                    uid:this.userData.id,
                    product_id:this.id,
                    pay_type:"NATIVE",
                    other_info:other_info
                },res => {
                    this.codeInfo = res.data
                    this.codeShow = true
                    this.clearTime = setInterval(() =>{
                        this.$post("/system/pay/checkWechatOrder",{
                            order_num:res.data.order_num
                        },res => {
                            if(res.data == 1){
                                clearInterval(this.clearTime)
                                this.$get("/system/wechat_app/user_info",{
                                    phone: this.userData.phone
                                },res => {  
                                    localStorage.data=JSON.stringify(res.data)
                                    this.codeShow = false
                                    this.$message.success('支付成功')
                                    this.$emit('toCenter','个人中心')
                                })
                            }
                        })

                    },4000)
                })
            }else{
                // 支付宝支付,支付成功后跳转个人中心
                // this.axios.post('https://guigui.admin.thinkerx.com/pay/buyCloudAli',{
                //     product_id:this.id,
                //     uid:this.userData.id,
                //     returnUrl:'https://www.guigui.com.cn/?now=%e4%b8%aa%e4%ba%ba%e4%b8%ad%e5%bf%83',
                //     other_info:other_info
                // }).then(resp => {
                //     let res=resp.data.data
                //     document.body.innerHTML+=res
                //     document.forms['alipaysubmit'].submit();
                // })
                this.$post("/system/pay/buyCloudAli",{
                    product_id:this.id,
                    uid:this.userData.id,
                    returnUrl:'https://www.guigui.com.cn/?now=%e4%b8%aa%e4%ba%ba%e4%b8%ad%e5%bf%83',
                    other_info:other_info
                },resp => {
                    let res=resp.data
                    document.body.innerHTML+=res
                    document.forms['alipaysubmit'].submit();
                })
            }
        },
        noPay(){
            this.codeShow = false
            this.$message('取消支付')
            clearInterval(this.clearTime)
        },
    },
    async mounted(){
        let that = this
        that.userData = JSON.parse(localStorage.data)
        this.id = this.buyId
        this.phone = this.userData.phone
        this.getAddress()
        //更新价格
        this.$get('/guigui/price/getAppPrice',{},res => {
            let price=res.data
            for(let i = 0,len=price.length;i<len;i++){
                if(price[i].id==21){
                    that.cards[0].price=price[i].price
                    that.cards[0].exp=price[i].unit
                }
                if(price[i].id==22){
                    that.cards[1].price=price[i].price
                    that.cards[1].exp=price[i].unit
                }
                if(price[i].id==that.id){
                    that.product=price[i]
                }
            }
        })
    }
}
</script>